import { useEffect, useState } from "react"
import * as yup from "yup"
import { yupResolver } from "@hookform/resolvers/yup"
import { useForm } from "react-hook-form"
import { Typography } from "@stardust-ds/react"
import intl from "react-intl-universal"

import Modal from "../../molecules/Modal"
import TrashIcon from "../../../assets/icons/TrashIcon"
import Input from "../../atoms/Input"
import Button from "../../atoms/Button"
import styles from "./index.module.scss"
import EyeSlashIcon from "../../../assets/icons/EyeSlashIcon"
import EyeIcon from "../../../assets/icons/EyeIcon"

export default function ModalConfirmDelete(props) {
  const {
    isOpen,
    fnOnClose,
    text,
    headerText,
    bOnDelete,
    fnSetDelete,
    idPainel,
    fnHandleDelete,
    bHasPassword = true
  } = props

  const schema = yup.object().shape({
    password: yup
      .string()
      .min(6, intl.get("DeleteModal.password_validation", { min: 6 }))
      .required(intl.get("form.required_field")),
    id: yup.number(),
  })
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    setError,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  })

  const [bDeleteLoading, setFnBDeleteLoading] = useState(false)
  const [passwordHidden, setPasswordHidden] = useState(true)
  const handleClick = () => setPasswordHidden(!passwordHidden)
  const showPassword = passwordHidden ? (
    <div className={styles.inputIcon}>
      <EyeSlashIcon />
    </div>
  ) : (
    <div className={styles.inputIcon}>
      <EyeIcon className={styles.inputIcon} />
    </div>
  )

  useEffect(() => {
    setValue("id", idPainel)
  }, [idPainel])

  async function fnSubmitDelete(data) {
    if (bOnDelete) {
      setFnBDeleteLoading(true)
      const response = await fnHandleDelete(data)
      setFnBDeleteLoading(false)

      // handle invalid password
      const aInvalidPasswordMessages = ["invalid password", "senha inválida"]
      const bIsInvalidPassword = aInvalidPasswordMessages.includes(response?.response?.data?.message?.toLowerCase())
      if (bIsInvalidPassword) {
        setError("password", { message: intl.get("DeleteModal.invalid_password") })
        return
      }

      reset({
        password: "",
      })
      fnOnClose(false)
      fnSetDelete?.(false)
    }
  }

  const handleCancelModal = (e) => {
    if (bDeleteLoading) return

    if (bOnDelete) {
      reset({
        password: "",
      })
      e.preventDefault()
      fnOnClose?.(false)
      fnSetDelete?.(false)
    }
  }

  const cDeleteButtonType = !bHasPassword ? "button" : !bOnDelete && "submit"

  function fnDeleteButtonClick(e) {
    if (!bHasPassword) {
      fnSubmitDelete(idPainel)
    }
    return !bOnDelete && fnSubmitDelete(e)
  }

  return (
    <>
      <Modal isOpen={isOpen}>
        <Modal.Header onClose={handleCancelModal}>
          {headerText}
        </Modal.Header>
        <form
          onSubmit={handleSubmit(fnSubmitDelete)}
          className={styles.formContainer}
        >
          <Modal.Content>
            <div className={styles.contentContainer}>
              <TrashIcon
                className={styles.trashIcon}
                width="80px"
                height="80px"
                fill="red"
              />
              <Typography color="#415364" type="p1">
                {text}
              </Typography>
              {bHasPassword && (
                <div style={{ width: "100%" }}>
                  <Typography textAlign="center" color="#415364" type="h5">
                    {intl.get("DeleteModal.to_continue_enter_password")}
                  </Typography>
                  <Input
                    isRequired
                    isFullWidth
                    type={passwordHidden ? "password" : "text"}
                    label={intl.get("DeleteModal.password")}
                    placeholder={intl.get("DeleteModal.password_here")}
                    iconRight={showPassword}
                    iconRightAction={handleClick}
                    {...register("password")}
                  />
                  <Typography color="#FF3541" type="p3">
                    {errors.password?.message}
                  </Typography>
                </div>
              )}
            </div>
          </Modal.Content>
          <Modal.Footer>
            <div className={styles.buttonFooter}>
              <Button
                variant="outline"
                onClick={handleCancelModal}
                disabled={bDeleteLoading}
                type="button"
              >
                {intl.get("cancel")}
              </Button>
              <Button
                variant="negative"
                type={cDeleteButtonType}
                onClick={fnDeleteButtonClick}
                isLoading={bDeleteLoading}
              >
                {intl.get("delete")}
              </Button>
            </div>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  )
}
